import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import FormulaValue from "../../../components/formula-value";
import FormulaName from "../../../components/formula-name";
import { getRequest } from '../../../../../api/ApiService';
import { fetchFinancialStatements } from '../../../../../api/FinancialStatementsService';
import Auth from '../../../../../routes/Auth';
import { Loader } from 'react-loaders';
import AbbreviatedMillionNumberFormat from "../../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class RoeStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      averageTotalEquity: 0,
      totalEquity: 0,
      netIncome: 0,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;
    const prevRound = rounds.find(i => i.number === activeRound - 1);
    const prevRoundId = prevRound ? prevRound.id : 0;

    Promise.all([
      fetchFinancialStatements({ roundLte: activeRound }),
      getRequest(`${process.env.REACT_APP_API_URL}v2/games/targets/?course=${Auth.getCourseId()}`),
    ])
      .then(([financialData, targetsRes]) => {
        const balanceSheet = financialData.balanceSheet;
        const currentRoundBalanceSheet = balanceSheet.find(i => i.Round === activeRound);
        const prevRoundBalanceSheet = balanceSheet.find(i => i.Round === activeRound - 1);

        let totalEquity = currentRoundBalanceSheet ? Number(currentRoundBalanceSheet['Total Equity'] || 0) : 0;
        if (prevRoundBalanceSheet) {
          const prevTotalEquity = Number(prevRoundBalanceSheet['Total Equity'] || 0);
          totalEquity = (totalEquity + prevTotalEquity) / 2;
        }

        const incomeStatement = financialData.incomeStatement;
        const currentRoundIncomeStatement = incomeStatement.find(i => i.Round === activeRound);
        const netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;

        const targets = targetsRes.body;
        const currentRoundTargets = targets.find(i => i.round_number === activeRound);
        const roeTarget = currentRoundTargets ? Number(currentRoundTargets.roe || 0) : 0;

        this.setState({
          loaded: true,
          averageTotalEquity: totalEquity * roeTarget,
          totalEquity,
          netIncome: netIncome,
        })
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      averageTotalEquity,
      totalEquity,
      netIncome,
    } = this.state;
    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="ROE"
        previousShownErrors={previousShownErrors}
        alertText="Your net profit was not enough."
        paragraph2={(
          <Fragment>
            Given your average total equity, your company needed to generate <b>${Number((averageTotalEquity / 1000000).toFixed(2))}M</b> in
            net profits in order to hit your ROE target.
          </Fragment>
        )}
        visual={(
          <Fragment>
            <FormulaName background="#a98df6">
              Return on Equity<br />
              (ROE)
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Net Profits
              <span className='divider' />
              Average Total Equity
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>

            <FormulaValue>
              <AbbreviatedMillionNumberFormat
                value={netIncome}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
              <span className='divider' />
              <AbbreviatedMillionNumberFormat
                value={totalEquity}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#d5d9dd',
          background: '#eae4f9',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default RoeStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/roe/step2.js